module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-32.a6937d11.svg";